// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1PUe5","consentsList":"PatientConsents_consentsList__3Uf17","consentsListEmpty":"PatientConsents_consentsListEmpty__1-kQu"};